// extracted by mini-css-extract-plugin
export default {"logo":"Header_logo__UsziS","ff-logo":"Header_ff-logo__n-PBd","logo-text":"Header_logo-text__iehbY"};